<template>
  <layout :tituloPagina="`Network | Routers | Edición | ${router.nombre} | ARP`">
    <div class="row">
      <div class="col-md-8">       
        <div class="card">
          <div class="card-header justify-content-between d-flex align-items-center">
            <h4 class="card-title text-truncate w-100">
              Lista de ARP del router {{ router.nombre }}
            </h4>
            <div class="me-2">
              <a href="#" onclick="return false;" @click="refrescarArpRouter()">
                <i class="mdi mdi-refresh text-success"></i>
              </a>
            </div>
            <div>
              <a href="#" onclick="return false;" @click="cerrar()">
                <i class="mdi mdi-close text-dark"></i>
              </a>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive" style="height: 620px">
              <table class="table table-hover table-nowrap align-middle" id="tabla-arp">
                <thead>
                  <tr>
                    <th></th>
                    <th>IP address</th>
                    <th>MAC address</th>
                    <th>Interface</th>
                    <th>Published</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="arp in arps" :key="arp.id">
                    <td>
                      <span :title="armarTitulo(arp)">
                        <strong>{{ armarEstado(arp) }}</strong>
                      </span>
                    </td>
                    <td>{{ arp.address }}</td>
                    <td>{{ arp["mac-address"] }}</td>
                    <td>{{ formatoPalabra(arp.interface) }}</td>
                    <td>{{ arp.published == true ? 'Si' : 'No' }}</td>
                    <td>{{ formatoPalabra(arp.status) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button class="btn btn-secondary" @click="atras()">
            <i class="mdi mdi-chevron-left"></i>
            Atrás
          </button>
          <button class="btn btn-success ms-1" @click="refrescarArpRouter()">
            <i class="mdi mdi-refresh"></i>
            Refrescar
          </button>
        </div>
      </div>
    </div>
    <br>
  </layout>
</template>

<script>
import Layout from "@/views/layouts/main"
import RouterSrv from '@/services/RouterSrv.js'

export default {
  name: 'ArpRouter',
  components: { Layout },
  data() {
    return {
      id_router: null,
      router: { 
        id: null,
        nombre: ''
      },
      arps: [],
      mostrar_spinner: true,
      intervals: {
        actualizacion: null
      },
    }
  },

  created: function() {
    var self = this

    self.id_router = self.$route.params.id
    self.cargarRouter()

    self.intervals.actualizacion = setInterval(function() {
      self.mostrar_spinner = false
      self.refrescarArpRouter()
    }, 10000)
  },
  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    atras: function() {
      this.$router.go(-1)
    },

    armarEstado: function(arp) {
      var self = this, estado = ''

      if (self.toBoolean(arp.dynamic))  estado += 'D'
      if (self.toBoolean(arp.complete)) estado += 'C'
      if (self.toBoolean(arp.disabled)) estado += 'X'

      return estado
    },

    armarTitulo: function(arp) {
      var self = this, partes = []

      if (self.toBoolean(arp.dynamic))  partes.push('D - Dynamic')
      if (self.toBoolean(arp.complete)) partes.push('C - Complete')
      if (self.toBoolean(arp.disabled)) partes.push('X - Disable')

      return partes.join(', ');
    },
    cerrar: function() {
      var self = this
      self.atras()
    },
    cargarRouter: function() {
      var self = this
      self.id_router = self.$route.params.id

      RouterSrv.routerJSON(self.id_router).then(response => {
        self.router = response.data

        self.refrescarArpRouter()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje) : ''
        console.log(error)
      })
    },
    formatoPalabra: function(palabra) {
      return palabra[0].toUpperCase() + palabra.slice(1);
    },
    toBoolean: function(value) {
      return value === true || value === 1 || value === '1' ||
            String(value).toLowerCase() === 'true' ||
            String(value).toLowerCase() === 'on' ||
            String(value).toLowerCase() === 'yes'
    },
    refrescarArpRouter: function() {
      var self = this

      if(self.mostrar_spinner) iu.spinner.mostrar("#tabla-arp")

      RouterSrv.arpJSON(self.id_router).then(response => {
        self.arps = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar los arp'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        if(self.mostrar_spinner) iu.spinner.ocultar("#tabla-arp")
        self.mostrar_spinner = true
      })
    }
  }
}
</script>

<style scoped>
</style>